import React from "react";
import * as Mui from "@mui/material";
import { themes } from "services/constants";
import { weekdays } from "pages/Administration/AdministrationHeaders";
import { CustomAutoComplete } from "components/CustomComponents";
import { tooltipStyleProps } from "services/constants/Styles";
export const ShiftAssignmentForWeekDays = ({
  WeekDaysData,
  setWeekDaysData,
  weekdayError,
  setUpdateData,
  // setUpdateWeekDaysShift,
}) => {
  const updateShiftDetails =
    (cycleid, weekday, shift_group_id) => (event, data) => {
      let ShiftCycleDetailsData = WeekDaysData;
      let updatedData = ShiftCycleDetailsData?.map((element) => {
        if (element?.shift_group_id === shift_group_id) {
          setUpdateData(false);
          return {
            ...element,
            cycles: element?.cycles?.map((weekItem) =>
              weekItem.cycle_number === cycleid
                ? {
                    ...weekItem,
                    assignments: weekItem?.assignments?.map((cyc) =>
                      cyc?.weekday === weekday
                        ? {
                            ...cyc,
                            shift_id: data?.id ?? "",
                            shift_name: data?.name ?? "",
                            shift_color: data?.color_code,
                          }
                        : cyc
                    ),
                  }
                : weekItem
            ),
          };
        } else {
          return element;
        }
      });
      setWeekDaysData(updatedData);
    };

  return (
    <React.Fragment>
      <Mui.Typography sx={{ fontWeight: 600 }}>Shift Assignment</Mui.Typography>

      {WeekDaysData?.length !== 0
        ? WeekDaysData.map((allData) => (
            <>
              <Mui.Typography sx={{ fontWeight: 600, mt: 2, color: "#09bd71" }}>
                {allData?.group_name}
              </Mui.Typography>

              <Mui.TableContainer
                sx={{
                  marginTop: 2,
                  marginLeft: "auto",
                  marginRight: "auto",
                  overflowX: "auto",
                  width: "100%",
                  maxWidth: 1300,
                }}
              >
                <Mui.Table
                  className="border"
                  sx={{
                    width: "100%",
                    tableLayout: "auto",
                    border: "1px solid #0000002b",
                  }}
                >
                  <Mui.TableHead
                    sx={{
                      backgroundColor: themes.primary,
                      position: "sticky",
                      top: -1,
                      zIndex: 10,
                    }}
                  >
                    <Mui.TableRow
                      sx={{
                        "& .MuiTableCell-root": {
                          height: "15px",
                          padding: "6px 5px",
                        },
                      }}
                    >
                      <Mui.TableCell
                        sx={{
                          fontSize: 13,
                          borderRight: "1px solid #0000002b",
                          borderBottom: "1px solid #0000002b",
                          verticalAlign: "center",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          backgroundColor: "#f5f5fd",
                          position: "sticky",
                          left: -1,
                          zIndex: 10,
                        }}
                      >
                        Cycle
                      </Mui.TableCell>
                      {weekdays.map((head) => (
                        <Mui.TableCell
                          sx={{
                            fontWeight: 600,
                            textAlign: "center",
                            borderRight: "1px solid #0000002b",
                            borderBottom: "1px solid #0000002b",
                          }}
                        >
                          {head.label}
                        </Mui.TableCell>
                      ))}
                    </Mui.TableRow>
                  </Mui.TableHead>

                  <Mui.TableBody>
                    {allData?.cycles?.map((item, index) => (
                      <Mui.TableRow
                        sx={{
                          "& .MuiTableCell-root": {
                            height: "30px",
                            padding: "3px 5px",
                          },
                        }}
                      >
                        <Mui.TableCell
                          sx={{
                            fontSize: 13,
                            borderRight: "1px solid #0000002b",
                            borderBottom: "1px solid #0000002b",
                            verticalAlign: "center",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            backgroundColor: "#f5f5fd",
                            position: "sticky",
                            left: -1,
                            zIndex: 10,
                          }}
                        >
                          Cycle {item?.cycle_number}
                        </Mui.TableCell>
                        {item?.assignments?.map((head) => (
                          <Mui.Tooltip
                            arrow
                            slotProps={tooltipStyleProps}
                            title={
                              head?.shift_name && head?.shift_name?.length > 15
                                ? head?.shift_name
                                : ""
                            }
                          >
                            <Mui.TableCell
                              sx={{
                                fontSize: 13,
                                borderRight: "1px solid #0000002b",
                                borderBottom: "1px solid #0000002b",
                                verticalAlign: "center",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                minWidth: 200,
                                maxWidth: 200,
                              }}
                            >
                              <CustomAutoComplete
                                dataList={allData?.shiftDetails?.map((obj) => ({
                                  ...obj,
                                  label: obj?.name,
                                }))}
                                selectedValue={head?.shift_name}
                                updateDataFunction={updateShiftDetails(
                                  item?.cycle_number,
                                  head?.weekday,
                                  allData?.shift_group_id
                                )}
                                placeHolder="Select the shift"
                              />

                              {head?.shift_name === "" && weekdayError ? (
                                <Mui.Typography
                                  variant="body3"
                                  color="error"
                                  sx={{
                                    fontSize: 13,
                                    paddingLeft: 0.5,
                                    padding: 0.5,
                                  }}
                                >
                                  Shift is required
                                </Mui.Typography>
                              ) : null}
                            </Mui.TableCell>
                          </Mui.Tooltip>
                        ))}
                      </Mui.TableRow>
                    ))}
                  </Mui.TableBody>
                </Mui.Table>
              </Mui.TableContainer>
            </>
          ))
        : null}
    </React.Fragment>
  );
};
